"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  DesignDraw: ['design-draw', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M18,21a1,1,0,0,0-1,1H4a.5.5,0,0,1-.5-.5v-.25A.25.25,0,0,0,3.25,21H1.75a.25.25,0,0,0-.25.25V22a2,2,0,0,0,2,2H17a2,2,0,0,0,2-2A1,1,0,0,0,18,21Z', 'M3.25,5a.25.25,0,0,0,.25-.25V2.5A.5.5,0,0,1,4,2H17a.5.5,0,0,1,.5.5V3.971a1,1,0,0,0,2,0V2a2,2,0,0,0-2-2H3.5a2,2,0,0,0-2,2v.75A.25.25,0,0,1,1.25,3H1A1,1,0,0,0,1,5Z', 'M3.25,10a.25.25,0,0,0,.25-.25V6.25A.25.25,0,0,0,3.25,6H1.75a.25.25,0,0,0-.25.25v1.5A.25.25,0,0,1,1.25,8H1a1,1,0,0,0,0,2Z', 'M3.25,15a.25.25,0,0,0,.25-.25v-3.5A.25.25,0,0,0,3.25,11H1.75a.25.25,0,0,0-.25.25v1.5a.25.25,0,0,1-.25.25H1a1,1,0,0,0,0,2Z', 'M3.25,20a.25.25,0,0,0,.25-.25v-3.5A.25.25,0,0,0,3.25,16H1.75a.25.25,0,0,0-.25.25V18H1a1,1,0,0,0,0,2Z', 'M9.87,6.674a1.113,1.113,0,0,1-1.377.765.75.75,0,1,0-.412,1.442,2.613,2.613,0,0,0,3.231-1.795A3.083,3.083,0,0,0,9.2,3.279,3.669,3.669,0,0,0,4.67,5.794a4.394,4.394,0,0,0,3.015,5.427.739.739,0,0,0,.207.029.75.75,0,0,0,.2-1.471A2.894,2.894,0,0,1,6.112,6.206,2.162,2.162,0,0,1,8.785,4.721,1.581,1.581,0,0,1,9.87,6.674Z', 'M9.594,16.887a.251.251,0,0,0-.4.073L8,19.582a.5.5,0,0,0,.662.662l2.621-1.191a.25.25,0,0,0,.074-.405Z', 'M23.243,18.961a.733.733,0,0,0-.349.076c-2.158,1.13-3.595,1.058-4.661-.227a.749.749,0,0,0-.577-.272h-2.8a1.1,1.1,0,1,1,0-2.2h2.8a2.1,2.1,0,0,0,1.482-3.579l-.059-.059a.249.249,0,0,1,0-.353l1.171-1.172a.252.252,0,0,1,.354,0l2.116,2.116a.75.75,0,1,0,1.06-1.06L21.488,9.936a.249.249,0,0,1,0-.353L23.3,7.768a1.5,1.5,0,0,0,0-2.122L22.6,4.939a1.5,1.5,0,0,0-2.121,0L18.219,7.194a.248.248,0,0,1-.265.057A6.218,6.218,0,0,0,9.61,11.918a.749.749,0,0,0,.6.876.73.73,0,0,0,.14.014.749.749,0,0,0,.735-.611,4.751,4.751,0,0,1,4.667-3.86,4.486,4.486,0,0,1,.707.058.25.25,0,0,1,.137.424L9.867,15.546a.14.14,0,0,0,0,.2L12.4,18.283a2.607,2.607,0,0,0,2.448,1.755h2.467a3.93,3.93,0,0,0,2.949,1.289,7.309,7.309,0,0,0,3.321-.961.743.743,0,0,0-.346-1.405Zm-5.755-5.379a.25.25,0,0,1,.354,0l.236.236a.6.6,0,0,1-.422,1.018h-.818a.25.25,0,0,1-.177-.427Z']],
  DesignDrawingBoard: ['design-drawing-board', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M11,23a1,1,0,1,0,2,0v-4.75a.25.25,0,0,0-.25-.25h-1.5a.25.25,0,0,0-.25.25Z', 'M3.105,22.551a1,1,0,0,0,1.79.894L7.437,18.36A.25.25,0,0,0,7.214,18H5.536a.249.249,0,0,0-.223.138Z', 'M19.105,23.445a1,1,0,0,0,1.79-.894l-2.208-4.415A.249.249,0,0,0,18.464,18H16.786a.25.25,0,0,0-.223.362Z', 'M23.5,16a1,1,0,0,0-1-1h-.75a.25.25,0,0,1-.25-.25V5.5A2.5,2.5,0,0,0,19,3H13.25a.25.25,0,0,1-.25-.25V1a1,1,0,1,0-2,0v1.75a.25.25,0,0,1-.25.25H5A2.5,2.5,0,0,0,2.5,5.5v9.25a.25.25,0,0,1-.25.25H1.5a1,1,0,1,0,0,2h21A1,1,0,0,0,23.5,16ZM4.5,5.5A.5.5,0,0,1,5,5H19a.5.5,0,0,1,.5.5v9.25a.25.25,0,0,1-.25.25H4.75a.25.25,0,0,1-.25-.25Z']],
  DesignDrawingBoard1: ['design-drawing-board-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M11,23a1,1,0,1,0,2,0v-3.75a.25.25,0,0,0-.25-.25h-1.5a.25.25,0,0,0-.25.25Z', 'M3.105,22.551a1,1,0,0,0,1.79.894L6.937,19.36A.25.25,0,0,0,6.714,19H5.036a.249.249,0,0,0-.223.138Z', 'M19.105,23.445a1,1,0,0,0,1.79-.894l-1.708-3.415A.249.249,0,0,0,18.964,19H17.286a.25.25,0,0,0-.223.362Z', 'M20.5,3H13.25a.25.25,0,0,1-.25-.25V1a1,1,0,1,0-2,0v1.75a.25.25,0,0,1-.25.25H3.5A2.5,2.5,0,0,0,1,5.5v9A2.5,2.5,0,0,0,3.5,17h17A2.5,2.5,0,0,0,23,14.5v-9A2.5,2.5,0,0,0,20.5,3Z']],
  DesignPenTool: ['design-pen-tool', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,3a2,2,0,0,0-2-2H2A2,2,0,0,0,0,3V21a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2ZM5.5,3.583a1,1,0,1,1,1,1A1,1,0,0,1,5.5,3.583Zm3.5,0a1,1,0,1,1,1,1A1,1,0,0,1,9,3.583Zm-6-1a1,1,0,1,1-1,1A1,1,0,0,1,3,2.583ZM22,20.5a.5.5,0,0,1-.5.5H2.5a.5.5,0,0,1-.5-.5V7a.5.5,0,0,1,.5-.5h19A.5.5,0,0,1,22,7Z', 'M19.75,15.5a1.252,1.252,0,0,0-1.25-1.25H15.963l-.292-.586A.75.75,0,0,0,15,13.25H13a1.252,1.252,0,0,0-1.25,1.25v4A1.252,1.252,0,0,0,13,19.75h5.5a1.252,1.252,0,0,0,1.25-1.25ZM18.25,18a.25.25,0,0,1-.25.25H13.5a.25.25,0,0,1-.25-.25V15a.25.25,0,0,1,.25-.25h.882a.252.252,0,0,1,.224.138l.223.448a.75.75,0,0,0,.671.414H18a.25.25,0,0,1,.25.25Z', 'M10.5,13a1.5,1.5,0,0,0,1.436-1.067l5.972-1.406a1.5,1.5,0,1,0-.344-1.46l-5.972,1.406A1.5,1.5,0,1,0,10.5,13Z', 'M3.75,16.5A1.252,1.252,0,0,0,5,17.75H7A1.252,1.252,0,0,0,8.25,16.5v-6A1.252,1.252,0,0,0,7,9.25H5A1.252,1.252,0,0,0,3.75,10.5Zm1.75-.25A.25.25,0,0,1,5.25,16V14.5a.25.25,0,0,1,.25-.25h1a.25.25,0,0,1,.25.25V16a.25.25,0,0,1-.25.25Zm1-5.5a.25.25,0,0,1,.25.25v1.5a.25.25,0,0,1-.25.25h-1a.25.25,0,0,1-.25-.25V11a.25.25,0,0,1,.25-.25Z']],
  DesignMonitorPencil: ['design-monitor-pencil', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,1.5A1.5,1.5,0,0,0,22.5,0H1.5A1.5,1.5,0,0,0,0,1.5v16A1.5,1.5,0,0,0,1.5,19h21A1.5,1.5,0,0,0,24,17.5V1.5ZM2.5,15a.5.5,0,0,1-.5-.5V2.5A.5.5,0,0,1,2.5,2h19a.5.5,0,0,1,.5.5v12a.5.5,0,0,1-.5.5Z', 'M16.449,23.213l-2.1-2.532a.5.5,0,0,0-.385-.181h-3.93a.5.5,0,0,0-.385.181l-2.1,2.532A.5.5,0,0,0,7.96,24h8.079a.5.5,0,0,0,.41-.787Z', 'M9.5,9h4a.5.5,0,0,0,.469-.672L12.423,4.115a1,1,0,0,0-1.854.021L9.031,8.328A.5.5,0,0,0,9.5,9Z', 'M10.75,10.75a.25.25,0,0,0-.25-.25H9a.5.5,0,0,0-.5.5v2a.5.5,0,0,0,.5.5h1.5a.25.25,0,0,0,.25-.25Z', 'M14.5,11a.5.5,0,0,0-.5-.5H12.5a.25.25,0,0,0-.25.25v2.5a.25.25,0,0,0,.25.25H14a.5.5,0,0,0,.5-.5Z']],
  DesignToolPen1: ['design-tool-pen_1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21.5,9.5A9.5,9.5,0,1,0,8.346,18.261a.248.248,0,0,1,.154.23V20a2,2,0,0,0,2,2h.25a.25.25,0,0,1,.25.25V23a1,1,0,0,0,2,0v-.75a.25.25,0,0,1,.25-.25h.25a2,2,0,0,0,2-2V18.491a.248.248,0,0,1,.154-.23A9.508,9.508,0,0,0,21.5,9.5Zm-8.5,6a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5V11a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5Zm-4.5-6a.5.5,0,0,1-.429-.757l3.5-5.834a.52.52,0,0,1,.858,0l3.5,5.834A.5.5,0,0,1,15.5,9.5ZM8,11a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5v3.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5Zm8,3.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5V11a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5Z']],
  DesignToolShape: ['design-tool-shape', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M13.8,8.965a.25.25,0,0,0,.435.1A3.374,3.374,0,0,0,15,6.917,3.421,3.421,0,0,0,11.583,3.5a3.377,3.377,0,0,0-2.143.769.25.25,0,0,0,.1.435A6.013,6.013,0,0,1,13.8,8.965Z', 'M17.75,8.5h2a.75.75,0,0,0,0-1.5h-2a.75.75,0,0,0,0,1.5Z', 'M17.75,11.5h1a.75.75,0,0,0,0-1.5h-1a.75.75,0,0,0,0,1.5Z', 'M7.75,19.25H4.25a.75.75,0,0,0,0,1.5h3.5a.75.75,0,0,0,0-1.5Z', 'M17.75,5.5h2a.75.75,0,0,0,0-1.5h-2a.75.75,0,0,0,0,1.5Z', 'M24,1.98A1.982,1.982,0,0,0,22.02,0H1.98A1.982,1.982,0,0,0,0,1.98V22.02A1.982,1.982,0,0,0,1.98,24H22.02A1.982,1.982,0,0,0,24,22.02ZM22,21.5a.5.5,0,0,1-.5.5l-19,.02a.5.5,0,0,1-.5-.5L1.98,2.5a.5.5,0,0,1,.5-.5L21.5,1.98a.5.5,0,0,1,.5.5Z', 'M3.500 10.500 A4.500 4.500 0 1 0 12.500 10.500 A4.500 4.500 0 1 0 3.500 10.500 Z', 'M14.177,15.363a.251.251,0,0,1,.073.177v3.71A1.252,1.252,0,0,0,15.5,20.5h3.75a1.252,1.252,0,0,0,1.25-1.25v-3.5a1.252,1.252,0,0,0-1.25-1.25H15.538a.251.251,0,0,1-.177-.073L13.905,12.97a.782.782,0,0,0-1.06,0,.748.748,0,0,0-.006,1.053l.006.007ZM18.75,16a.25.25,0,0,1,.25.25v2.5a.25.25,0,0,1-.25.25H16a.25.25,0,0,1-.25-.25V17.539a.25.25,0,0,1,.427-.177l.668.668a.75.75,0,0,0,1.06-1.06l-.543-.543A.25.25,0,0,1,17.539,16Z']],
  DesignDrawingBoardEducation: ['design-drawing-board-education', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M2.106,22.551a1,1,0,0,0,1.789.894L6.438,18.36a.255.255,0,0,0-.011-.244A.252.252,0,0,0,6.214,18H4.537a.249.249,0,0,0-.224.138Z', 'M6.922,17A.079.079,0,0,0,7,16.921a2.5,2.5,0,0,1,.572-1.514A.25.25,0,0,0,7.38,15H3.75a.25.25,0,0,1-.25-.25V5.5A.5.5,0,0,1,4,5H18a.5.5,0,0,1,.5.5v6.883a.252.252,0,0,0,.166.236l1.5.535a.25.25,0,0,0,.334-.235V5.5A2.5,2.5,0,0,0,18,3H12.25a.25.25,0,0,1-.25-.25V1a1,1,0,1,0-2,0v1.75A.25.25,0,0,1,9.75,3H4A2.5,2.5,0,0,0,1.5,5.5v9.25a.25.25,0,0,1-.25.25H1a1,1,0,0,0,0,2Z', 'M21,20.077a.249.249,0,0,0-.348-.229l-3.561,1.526a1.509,1.509,0,0,1-1.182,0l-3.56-1.526a.251.251,0,0,0-.349.229v1.468a1.251,1.251,0,0,0,.8,1.166l3.236,1.194a1.237,1.237,0,0,0,.917,0l.995-.367a.25.25,0,0,1,.28.075.987.987,0,0,0,1.221.271.977.977,0,0,0,.535-.916.251.251,0,0,1,.164-.242l.068-.025A1.246,1.246,0,0,0,21,21.545Z', 'M9,21a1,1,0,0,0,2,0v-1.56a.249.249,0,0,0-.151-.23l-1.5-.643A.251.251,0,0,0,9,18.8Z', 'M23.668,16.527l-7-2.5a.5.5,0,0,0-.336,0l-7,2.5a.5.5,0,0,0-.028.93l7,3a.494.494,0,0,0,.393,0l7-3A.5.5,0,0,0,23.668,16.527Z']],
  DesignToolLayout: ['design-tool-layout', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,1.98A1.982,1.982,0,0,0,22.02,0H1.98A1.982,1.982,0,0,0,0,1.98V22.02A1.982,1.982,0,0,0,1.98,24H22.02A1.982,1.982,0,0,0,24,22.02ZM22,21.5a.5.5,0,0,1-.5.5l-19,.02a.5.5,0,0,1-.5-.5L1.98,2.5a.5.5,0,0,1,.5-.5L21.5,1.98a.5.5,0,0,1,.5.5Z', 'M4.5,16.5h11a1,1,0,0,0,1-1V4.5a1,1,0,0,0-1-1H4.5a1,1,0,0,0-1,1v11A1,1,0,0,0,4.5,16.5Zm.833-3.343,1.584-3.083a.749.749,0,0,1,1.164-.219L9.3,10.936a.252.252,0,0,0,.386-.069l1.735-3.222a.75.75,0,0,1,1.375.127l1.75,5.5a.75.75,0,0,1-.715.978H6a.75.75,0,0,1-.667-1.093Z', 'M13.000 18.000 L16.000 18.000 L16.000 20.500 L13.000 20.500 Z', 'M17.500 18.000 L20.500 18.000 L20.500 20.500 L17.500 20.500 Z', 'M4.25,20h4.5a.75.75,0,0,0,0-1.5H4.25a.75.75,0,0,0,0,1.5Z', 'M18.75,5h1a.75.75,0,0,0,0-1.5h-1a.75.75,0,0,0,0,1.5Z', 'M18.75,8.5h1a.75.75,0,0,0,0-1.5h-1a.75.75,0,0,0,0,1.5Z', 'M18.75,12h1a.75.75,0,0,0,0-1.5h-1a.75.75,0,0,0,0,1.5Z']],
  DesignToolFibonacci: ['design-tool-fibonacci', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M18.731,14a.25.25,0,0,0,.25-.263,12.594,12.594,0,0,0-5.23-9.747A15.287,15.287,0,0,0,5.375,1.017C5,1,4.6,1.009,4.235,1.03A.249.249,0,0,0,4,1.279V13.75a.25.25,0,0,0,.25.25Z', 'M5,21.107A5.214,5.214,0,0,1,4,18v4.5A1.5,1.5,0,0,0,5.5,24h5.977a9.186,9.186,0,0,1-4.218-1A6.5,6.5,0,0,1,5,21.107Z', 'M5,15.265A.157.157,0,0,0,4.885,15H4.25a.25.25,0,0,0-.25.25V18A3.858,3.858,0,0,1,5,15.265Z', 'M8.5,17c-.676,0-.915.581-.915,1.078a1.509,1.509,0,0,0,.351.981A1.342,1.342,0,0,0,9,19.5c1.065,0,2-.7,2-1.5a2.934,2.934,0,0,0-3-3,2.892,2.892,0,0,0-3,3,4.221,4.221,0,0,0,1.291,3.082,7.2,7.2,0,0,0,4.437,1.885.252.252,0,0,0,.191-.064A.255.255,0,0,0,11,22.718V20.251a.219.219,0,0,0-.109-.189.215.215,0,0,0-.218,0A3.373,3.373,0,0,1,9,20.5a2.32,2.32,0,0,1-1.818-.784,2.523,2.523,0,0,1-.6-1.638A1.936,1.936,0,0,1,8.5,16a.5.5,0,0,1,0,1Z', 'M12,18v4.712a.251.251,0,0,0,.275.249c3.113-.308,6.412-2.458,6.7-7.7a.256.256,0,0,0-.068-.186A.251.251,0,0,0,18.729,15h-7.44a.252.252,0,0,0-.227.144.249.249,0,0,0,.034.265A4.024,4.024,0,0,1,12,18Z', 'M19,19.361A7.935,7.935,0,0,1,15.56,23,8.644,8.644,0,0,1,11.5,24h7A1.5,1.5,0,0,0,20,22.5s0-2.327,0-4.388a.25.25,0,0,0-.489-.074A9.546,9.546,0,0,1,19,19.361Z', 'M20,1.5A1.5,1.5,0,0,0,18.5,0H8.756a.25.25,0,0,0-.064.492C9.229.633,9.764.8,10.293,1a16.51,16.51,0,0,1,4.055,2.188A13.826,13.826,0,0,1,19,9.105a13.544,13.544,0,0,1,.511,1.524A.25.25,0,0,0,20,10.564C20,6.864,20,1.5,20,1.5Z']],
  DesignToolWireframe: ['design-tool-wireframe', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12.062,20.131a.251.251,0,0,0-.422.128L11.012,23.4a.5.5,0,0,0,.49.6.473.473,0,0,0,.1-.01l3.143-.629a.25.25,0,0,0,.127-.422Z', 'M23.228,11.765a2.62,2.62,0,0,0-3.7,0l-6.5,6.5a.5.5,0,0,0,0,.707l3,3a.5.5,0,0,0,.707,0l6.5-6.5A2.621,2.621,0,0,0,23.228,11.765Z', 'M3.500 3.500 L15.000 3.500 L15.000 8.000 L3.500 8.000 Z', 'M8.123,9.5H4a.5.5,0,0,0-.5.5v6a.5.5,0,0,0,.5.5H9.837a.5.5,0,0,0,.481-.637l-1.714-6A.5.5,0,0,0,8.123,9.5Z', 'M12.433,16.5a.577.577,0,0,0,.406-.167l1.868-1.869A1,1,0,0,0,15,13.757V10a.5.5,0,0,0-.5-.5H10.663a.5.5,0,0,0-.481.638l1.7,5.946A.573.573,0,0,0,12.433,16.5Z', 'M10.577,18H2.5a.5.5,0,0,1-.5-.5V2.5A.5.5,0,0,1,2.5,2H16a.5.5,0,0,1,.5.5v9.567a.25.25,0,0,0,.427.177l1.279-1.279a1,1,0,0,0,.293-.707V2a2,2,0,0,0-2-2H2A2,2,0,0,0,0,2V18a2,2,0,0,0,2,2H9.751a.5.5,0,0,0,.49-.4l.048-.241a2.009,2.009,0,0,1,.477-.943A.251.251,0,0,0,10.577,18Z']],
  DesignShapeMonitor: ['design-shape-monitor', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,1.5A1.5,1.5,0,0,0,22.5,0H1.5A1.5,1.5,0,0,0,0,1.5v16A1.5,1.5,0,0,0,1.5,19h21A1.5,1.5,0,0,0,24,17.5Zm-2,13a.5.5,0,0,1-.5.5H2.5a.5.5,0,0,1-.5-.5V2.5A.5.5,0,0,1,2.5,2h19a.5.5,0,0,1,.5.5Z', 'M14.35,20.681a.5.5,0,0,0-.385-.181h-3.93a.5.5,0,0,0-.385.181l-2.1,2.532A.5.5,0,0,0,7.96,24h8.079a.5.5,0,0,0,.41-.787Z', 'M9.705,6.294a3.618,3.618,0,1,0-.585,7.212c.1.008.2.012.295.012a3.625,3.625,0,0,0,3.6-3.326h0A3.621,3.621,0,0,0,9.705,6.294Zm-.122,1.5a2.117,2.117,0,1,1-.172-.007C9.468,7.782,9.525,7.784,9.583,7.789Z', 'M17.033,3.25H10.967A1.218,1.218,0,0,0,9.75,4.467v.467a.75.75,0,1,0,1.5,0,.184.184,0,0,1,.184-.184H16.25a.5.5,0,0,1,.5.5v4.5a.5.5,0,0,1-.5.5H14.7a.75.75,0,0,0,0,1.5h2.333a1.218,1.218,0,0,0,1.217-1.217V4.467A1.218,1.218,0,0,0,17.033,3.25Z']],
  DesignToolPen: ['design-tool-pen', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21.5,19a1,1,0,0,0-1,1,2,2,0,0,1-4,0V5a5.006,5.006,0,0,0-5-5h-2a5.006,5.006,0,0,0-5,5v.5a1,1,0,0,0,2,0V5a3,3,0,0,1,3-3h2a3,3,0,0,1,3,3V20a4,4,0,0,0,8,0A1,1,0,0,0,21.5,19Z', 'M19,15a2.5,2.5,0,0,0,5,0V5.75a.25.25,0,0,0-.25-.25h-4.5a.25.25,0,0,0-.25.25Z', 'M23.947,4.276l-2-4a.521.521,0,0,0-.894,0l-2,4a.154.154,0,0,0,.138.224h4.618a.154.154,0,0,0,.138-.224Z', 'M10.75,13a.25.25,0,0,0,.25-.25V10.5A2.5,2.5,0,0,0,8.5,8h-2a.25.25,0,0,0-.25.25v4.5A.25.25,0,0,0,6.5,13Z', 'M4.75,8.25A.25.25,0,0,0,4.5,8h-2A2.5,2.5,0,0,0,0,10.5v2.25A.25.25,0,0,0,.25,13H4.5a.25.25,0,0,0,.25-.25Z', 'M0,18.5a5.5,5.5,0,0,0,11,0V14.75a.25.25,0,0,0-.25-.25H.25a.25.25,0,0,0-.25.25Z']]
};
exports["default"] = _default;